import React from "react";
import { Colors } from "../Constants/colors";

export const Divider = () => {
  return (
    <div className="pt-4 pb-4 w-full">
      <div
        className="w-full"
        style={{ border: `0.5px solid ${Colors.LightAshRose}` }}
      />
    </div>
  );
};
